/* eslint-ignore */
// @ts-nocheck
import styled from "styled-components";

export const TooltipContainer = styled.div`
  width: 418px;
  background: #97f8fb;
  padding: 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  position: absolute;
  bottom: -50px;
  left: 42px;
  color: #0b29fb;
  opacity: 0;
  transition: opacity 0.4s;
  visibility: hidden;

  &::before {
    content: "";
    border-style: solid;
    top: 16px;
    position: absolute;
    left: -6px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #97f8fb;
    border-left: none;
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;

  &:hover ${TooltipContainer} {
    opacity: 1;
    visibility: visible;
  }
`;

export const TolltipItens = styled.div`
  text-align: initial;
`;
